import { Link } from 'react-router-dom';
import { GraduationCap } from 'lucide-react';

export default function CourseCard({ course, large = false }) {
  return (
    <Link
      to={`/courses/${course.slug}`}
      className="block bg-white rounded-2xl overflow-hidden border border-orange-100/60 hover:shadow-xl hover:shadow-brand/10 transition-all group"
    >
      {course.hero_image_url ? (
        <img src={course.hero_image_url} alt="" className={`w-full object-cover ${large ? 'h-52' : 'h-40'}`} />
      ) : (
        <div className={`w-full bg-gradient-to-br from-brand/15 to-brand/5 flex items-center justify-center ${large ? 'h-52' : 'h-40'}`}>
          <GraduationCap className="text-brand/40" size={large ? 56 : 40} />
        </div>
      )}
      <div className="p-5">
        <h3 className={`font-bold text-slate-900 group-hover:text-brand transition-colors ${large ? 'text-xl' : 'text-lg'}`}>
          {course.title}
        </h3>
        <p className="text-sm text-slate-600 line-clamp-2 mt-2">{course.short_description}</p>
        <div className="mt-4 flex items-center justify-between">
          <span className="text-sm font-bold text-brand">
            {course.price_cents === 0 ? 'Free' : `$${(course.price_cents / 100).toFixed(2)}`}
          </span>
          {course.duration_minutes && (
            <span className="text-xs text-slate-500">{course.duration_minutes} min</span>
          )}
        </div>
      </div>
    </Link>
  );
}
